import seguridad from "@/components/seguridad/api/app/Seguridad.js";
import mainStore from "@/store";
import router from "@/router";

export default {
  autenticar(usuario, contrasena, dispositivo) {
    let url = `/autenticar/`;
    let body = { usuario, contrasena, dispositivo: dispositivo };
    return seguridad.post(url, body);
  },cerrarSesion: async function () {
      let url = `/api/autorizacion/cerrar-sesion/`;

      try {
        // 1. Enviar petición a JAVA antes de borrar nada
        await seguridad.post(url, {}, { withCredentials: true });
      } catch (e) {
        // Incluso si Java falla, igual continuamos
        console.warn("Cerrar sesión JAVA falló:", e); // eslint-disable-line  
      }

      // 2. Borrar estado local recién DESPUÉS de cerrar sesión
      mainStore.state.seguridad.token = null;
      mainStore.state.seguridad.usuario = null;
      mainStore.state.seguridad.modulos = [];

      sessionStorage.removeItem("cartones-del-pacifico");
      localStorage.removeItem("cartones-del-pacifico");

      // 3. Ir al login
      router.replace({ name: "Login" });
    },
  registrarAcceso(modulo) {
    let url = `/api/autorizacion/aplicacion/${modulo.id}`;
    return seguridad.get(url);
  },
  obtenerModulos() {
    let url = `/api/modulos/usuario`;
    return seguridad.get(url);
  },
  cambiarContrasena(body) {
    let url = `/api/autorizacion/cambiar-contrasena`;
    return seguridad.post(url, body);
  },
  validarToken() {
    let url = `/api/autorizacion/validar`;
    return seguridad.get(url);
  },
  obtenerUsuariosPermiso(permiso) {
    let url = `/api/autorizacion/usuarios/${permiso}`;
    return seguridad.get(url);
  }
};
